import { apiBackendBaseUrl, enableApiMocks } from "@settings/env";

export const enableMocking = async () => {
  if (!enableApiMocks) return;
  if (import.meta.env.MODE === "test") return;

  const { worker } = await import("./browser");
  return worker.start({
    onUnhandledRequest(req, print) {
      if (!req.url.includes(apiBackendBaseUrl)) return;
      print.warning();
    },
  });
};
